class BatchCreateCandidateLeadReq {
    constructor() {
        this.candidates = [];
        this.candidateType = null;
    }
}

export default BatchCreateCandidateLeadReq;
